import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';

const STORAGE_KEY = 'qr-app-lang';

function getInitialLng(): string {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    if (s === 'es' || s === 'en') return s;
  } catch {
    /* ignore */
  }
  return 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: getInitialLng(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  /** Without a root Suspense boundary, default useSuspense causes useTranslation to throw until ready — blank page on client navigations (e.g. /oops). */
  react: {
    useSuspense: false,
  },
});

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    /* ignore */
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language;
}

export default i18n;
